import _ from 'lodash';
import { VIDEO_STATUS } from '../reducers/event';
import 'abortcontroller-polyfill';
import axios from 'axios';
import axiosRetry from 'axios-retry';

// Terminate fetch
const controller = new AbortController();
const signal = controller.signal;

const requestAbort = () => {
  controller.abort();
  console.log('abort executed');
};

const oneroomAdminAPI = axios.create({
  baseURL: ENV.API_ENDPOINT,
  timeout: 5000,
  headers: {
    accept: 'application/json',
    'content-type': 'application/json',
    'x-api-key': ENV.API_KEY,
  },
});

axiosRetry(oneroomAdminAPI, {
  retries: 5,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
  retryCondition: (error) => {
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) ||
      (!!error?.response?.status && error.response.status >= 500)
    );
  },
});

const requestCamList = async (EVENT_ID) => {
  return oneroomAdminAPI
    .get('/getEventStreamingUrls', {
      params: {
        eventId: EVENT_ID,
      },
    })
    .then((res) => res.data);
};

const _requestCamList = (EVENT_ID, CALLBACK = undefined) => {
  oneroomAdminAPI
    .get('/getEventStreamingUrls', {
      // headers: {
      //  'Authorization': TOKEN,
      // },
      params: {
        eventId: EVENT_ID,
      },
    })
    .then(function (response) {
      if (CALLBACK !== undefined) {
        CALLBACK(response.data);
      }
    })
    .catch(function (error) {
      // console.log('fetch getEventStreamingUrls:', error);
    });
};

const generatePlaylist = (ARRAY_DATA) => {
  const playList = [];
  _.forEach(ARRAY_DATA, function (item) {
    // pick meaningful keys
    const pick = _.pick(item, ['cameraId', 'url', 'status', 'cameraTitle']);
    // let camId ='';
    const keyrename = _.mapKeys(pick, function (value, key) {
      let result;
      switch (key) {
        case 'cameraId':
          // camId = value;
          result = 'id';
          break;
        case 'url':
          result = 'file';
          break;
        case 'status':
          result = 'status';
          break;
        case 'cameraTitle':
          result = 'title';
          break;
        default:
          result = undefined;
      }
      return result;
    });

    keyrename.image = undefined; // 'https://cdn.jwplayer.com/v2/media/OeXvqtdD/poster.jpg?width=1920'; this returns image url WITHOUT file extension
    keyrename.camthumb = undefined;
    playList.push(keyrename);
  });
  // console.log('add image',playList);
  return playList;
};

const getValidPlaylist = (ARRAY_DATA) => {
  return ARRAY_DATA.filter(
    (item) =>
      item.status == VIDEO_STATUS.streaming ||
      item.status == VIDEO_STATUS.archived ||
      item.status == VIDEO_STATUS.archivedS3,
  );
};

const Viewer = {
  requestAbort,
  _requestCamList,
  requestCamList,
  generatePlaylist,
  getValidPlaylist,
};

export default Viewer;
